export const tagColors = [
  "#BBE9FF",
  "#FF76CE",
  "#C4D7FF",
  "#FFD7C4",
  "#EDDFE0",
  "#E5D9F2",
  "#EEDF7A",
];
